import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconChartVertical = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19C19 18.4477 18.5523 18 18 18H6C5.44772 18 5 18.4477 5 19ZM8 8C7.44772 8 7 8.44772 7 9L7 16C7 16.5523 7.44772 17 8 17C8.55228 17 9 16.5523 9 16V9C9 8.44772 8.55228 8 8 8ZM12 4C11.4477 4 11 4.44772 11 5V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16L13 5C13 4.44772 12.5523 4 12 4ZM15 11C15 10.4477 15.4477 10 16 10C16.5523 10 17 10.4477 17 11V16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16V11Z"
        />
      </svg>
    );
  }
);
